import { render, staticRenderFns } from "./DocumentationServiceEdit.vue?vue&type=template&id=464a5202"
import script from "./DocumentationServiceEdit.vue?vue&type=script&lang=js"
export * from "./DocumentationServiceEdit.vue?vue&type=script&lang=js"
import style0 from "./DocumentationServiceEdit.vue?vue&type=style&index=0&id=464a5202&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('464a5202')) {
      api.createRecord('464a5202', component.options)
    } else {
      api.reload('464a5202', component.options)
    }
    module.hot.accept("./DocumentationServiceEdit.vue?vue&type=template&id=464a5202", function () {
      api.rerender('464a5202', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DocumentationServiceEdit.vue"
export default component.exports